import { useSelector } from "react-redux";
import { flight_dateTimeFormat, set_flight_fare } from "../../pages/Home";
import "./FlightSearch.css";

const SaleSummary = (props) => {
  const fare_quote = props
  const Segments = fare_quote.status ? fare_quote.Results.Segments : []
  const FareBreakdown = fare_quote.status ? fare_quote.Results.FareBreakdown : []
  const airlines = useSelector((state) => state.global.airlines);
  var amount = 0

  return (
    <>
      <div className="col-lg-3">
        <div class="card" style={{ width: "20rem" }}>
          <div class="card-header">Sale Summary</div>
          <ul class="list-group list-group-flush">
            <li class="">
              <button type="button" class="btn btn-link">
                + Show details
              </button>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-lg-4">{flight_dateTimeFormat(fare_quote.Results.Segments[0][0].Origin.DepTime)}</div>
                <div class="col-lg-3">{fare_quote.Results.Segments[0][0].Airline.AirlineCode + '' + fare_quote.Results.Segments[0][0].Airline.FlightNumber}</div>
                <div class="col-lg-5">{fare_quote.Results.Segments[0][0].Airline.FareClass} class</div>
              </div>
            </li>
            <li class="list-group-item">
              {Segments.length
                ?
                Segments.map((datas, seg_ind) => {
                  const have_next_asset = Segments.length > 1 ? true : false
                  const total_assets = datas.length
                  return datas.map((airport, index) => {
                    return <>
                      <>
                        {seg_ind == 0 && index == 0 ?

                          <div class="row">

                            <div class="col-lg-4">Dept:</div>
                            <div class="col-lg-3">{airport.Origin.Airport.AirportCode}</div>
                            <div class="col-lg-5">@{flight_dateTimeFormat(airport.Origin.DepTime)}</div>
                          </div>
                          : ''}

                        {have_next_asset ? (seg_ind == 1 && index == datas.length - 1 ?
                          <div class="row">
                            <div class="col-lg-4">Arr:</div>
                            <div class="col-lg-3">{airport.Destination.Airport.AirportCode}</div>
                            <div class="col-lg-5">@{flight_dateTimeFormat(airport.Destination.ArrTime)}</div>
                          </div>
                          : "") : (seg_ind == 0 && index == datas.length - 1 ?
                            <div class="row">
                              <div class="col-lg-4">Arr:</div>
                              <div class="col-lg-3">{airport.Destination.Airport.AirportCode}</div>
                              <div class="col-lg-5">@{flight_dateTimeFormat(airport.Destination.ArrTime)}</div>
                            </div>

                            : "")}


                      </>

                    </>
                  })
                })
                : ""
              }
            </li>
          </ul>
          <div class="card-header">Fare / Pax Type</div>
          {
            FareBreakdown.map((dt) => {
              amount += dt.BaseFare + dt.Tax
              return (
                <li class="list-group-item">
                  <div class="row">
                    <div class="col-lg-7">{dt.PassengerType == 1 ? 'Adult' : dt.PassengerType == 2 ? 'Child' : dt.PassengerType == 3 ? 'Infant' : ''} x {dt.PassengerCount}</div>
                    <div class="col-lg-5">Rs {dt.BaseFare}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-7">Tax</div>
                    <div class="col-lg-5">Rs {dt.Tax}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-7">T.fee and S. charges</div>
                    <div class="col-lg-5">Rs {0.00}</div>
                  </div>
                </li>
              )
            })
          }

          <div class="card-header">
            <div class="row">
              <div class="col-lg-7">Other Charges</div>
              <div class="col-lg-5">Rs {set_flight_fare(fare_quote.Results.Fare,
                fare_quote.Results.AirlineCode, airlines) - amount}</div>
            </div>
            <div class="row">
              <div class="col-lg-7">Total Pub fare</div>
              <div class="col-lg-5">Rs {set_flight_fare(fare_quote.Results.Fare,
                fare_quote.Results.AirlineCode, airlines)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SaleSummary;
